import {
  AccountSignInWithGoogleAction,
  SIGN_IN_GOOGLE_REQUESTED,
} from './account_types';

export const signInWithGoogle = (): AccountSignInWithGoogleAction => ({
  type: SIGN_IN_GOOGLE_REQUESTED,
  payload: {},
});
